import Vue from "vue";
import Vuex from "vuex";
import { getLocale, setLocale } from "@/localeCook";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      userId: null,
      username: "",
      telNum: "",
      roleName: "",
      roleType: 1,
      monitor: false,
      expireDate: "",
      accountType: 0,
    },
    // logoUrl: require("@/assets/img/index/logo.png"),
    logoUrl: require("@/assets/img/logo.png"),
    defaultLogoUrl: require("@/assets/img/logo_w.png"),
    permissions: [],
    dataPermissionList: ["全部"],
    areaNameList: [],
    currentArea: ["全部"],
    fieldPermissions: [],
    indexPermissions: [],
    isLoadIndexPermissions: false,
    isHasIndexPermissions: false,
    buttons: [],
    pageScroll: {
      scroll: false,
      mode: "manual", // auto 和 manual
      interval: 3000, //页面滚动切换间隔
      scrollList: [
        // {
        //     title: "信息概览",
        //     index: 1,
        //     type: "page",
        //     path: "/index",
        //     name: "indexInfo",
        //     src: require("@/assets/img/index.jpg")
        // },
        // {
        //     title: "定制页 1",
        //     index: 3,
        //     type: "image",
        //     path: "/display/imagePage",
        //     name: "imagePage",
        //     src: require("@/assets/img/display_image.jpg")
        // }
      ],
    },
    curPageIndex: 1,
    interval: "",
    siderConfig: {
      siderWidth: "300px",
      isMenuCollapse: false,
      hideMenu: false,
      isHide: false,
    },
    notify: null,
    alarmTipsTimer: null,
    isStopAlarmTips: false,
    isCloseAlarmTips: true,
    alarmAudio: null,
    alarmAudioTimer: null,
    audioUrl: "",
    trapTimer: null,
    isLoadTop: true, //是否已加载顶部
    faultTask: {
      trapCount: 0,
      trapFinishRate: 0,
      trapArrivalOvertimeCount: 0,
      trapRescueOvertimeCount: 0,
    },
    trapLastUpdateTime: null,
    indexLiftStatusTimer: -1,
    indexDeviceStatusTimer: -1,
    indexRealTimer: -1,
    indexMapTimer: -1,
    checkIndexRealTimer: -1,
    deviceLiftStatusTimer: -1,
    alarmMonitorStatusTimer: -1,
    monitorStatusTimer: -1,
    allDayMonitorTimer: -1,
    switchMonitorTimer: -1,
    noticeTimer: -1,
    isExitNotice: true,
    isAutoCloseWS: true,
    ws: null, //websocket对象
    isShowMenu: true, //是否显示左边导航菜单
    isHiddenHeader: false, //是否隐藏头部
    routerTabList: [],
    deriveLoading: false,
  },
  mutations: {
    startPageScroll(state, form) {
      state.pageScroll.scroll = true;
      state.pageScroll.mode = form.mode;
      state.pageScroll.interval = form.interval;
    },
    exitPageScroll(state) {
      state.pageScroll.scroll = false;
    },
    setPageScrollList(state, value) {
      state.pageScroll.scrollList = value;
    },
    setPageScrollMode(state, mode) {
      state.pageScroll.mode = mode;
    },
    setPageScrollInterval(state, value) {
      state.pageScroll.interval = value;
    },
    setPageIndex(state, value) {
      if (value < 1) {
        value = state.pageScroll.scrollList.length;
      }
      if (value > state.pageScroll.scrollList.length) {
        value = 1;
      }
      state.curPageIndex = value;
    },
    siderCollapse(state) {
      state.siderConfig.siderWidth = "60px";
      state.siderConfig.isMenuCollapse = true;
    },
    siderExpand(state) {
      state.siderConfig.siderWidth = "300px";
      state.siderConfig.isMenuCollapse = false;
    },
    setWS(state, data) {
      state.ws = data;
    },
    SET_LOCALE: (state, payload) => {
      state.locale = payload;
    },
    setRouterTabList(state, data) {
      sessionStorage.setItem("routerTabList", JSON.stringify(data));
      state.routerTabList = data;
    },
    setDeriveLoading(state, data) {
      state.deriveLoading = data;
    },
  },
  actions: {},
  getters: {
    deriveLoading: (state) => state.deriveLoading,
    isMenuCollapse: (state) => state.siderConfig.isMenuCollapse,
  },
});
